import axios from "axios";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button as MuiButton,
  Dialog as MuiDialog,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  DialogTitle as MuiDialogTitle,
  FormControl as MuiFormControl,
  InputLabel as MuiInputLabel,
  MenuItem as MuiMenuItem,
  Select as MuiSelect,
} from "@mui/material";
import { Theme, useAlerts } from "common";
import ConfirmationDialog from "./Dialog/ConfirmationDialog";

const Export = (props) => {
  const { exportURL, displayName, downloadName, channel } = props;
  const { setAlert } = useAlerts();
  const { t } = useTranslation();
  const [openASConfirmation, setOpenASConfirmation] = useState(false);
  const QUALTRICS_FILE = "DE_QUALTRICS_FILE";
  const MARKETO_FILE = "DE_MARKETO_FILE";
  const DIRECT_EMAIL_CHANNEL = "DE";

  const [fileType, setFileType] = useState(QUALTRICS_FILE);

  const handleClickImport = () => {
    setOpenASConfirmation(true);
  };

  const closeCancelASConfirmation = (okOnClose) => {
    setOpenASConfirmation(false);
    setFileType(QUALTRICS_FILE);
    if (okOnClose) {
      handleDownloadFile();
    }
  };

  const handleSelectChange = (e) => {
    setFileType(e.target.value);
  };

  const handleDownloadFile = async () => {
    try {
      const apiUrl = exportURL + `?directEmailFileType=${fileType}`;

      const response = await axios.get(apiUrl);

      // save to local file system
      let aTag = document.createElement("a");
      aTag.href = "data:attachment/csv," + encodeURIComponent(response.data);
      aTag.target = "_blank";
      aTag.download = downloadName != null ? downloadName : displayName;
      document.body.appendChild(aTag);
      aTag.click();
      aTag.parentNode.removeChild(aTag);
    } catch (err) {
      // set error.message in AlertContext
      setAlert("error", err.message);
    }
  };

  const title = t("ExportFile.exportTitle");
  const message = t("ExportFile.exportMessage");
  const okLabel = t("common.yesLabel");
  const cancelLabel = t("common.noLabel");

  return (
    <>
      {channel === DIRECT_EMAIL_CHANNEL ? (
        <MuiDialog open={openASConfirmation}>
          <MuiDialogTitle id="confirmation-dialog-title">
            {title || ""}
          </MuiDialogTitle>
          <MuiDialogContent>
            <MuiFormControl fullWidth>
              <MuiInputLabel id="demo-simple-select-label">
                {t("ExportFile.select_label")}
              </MuiInputLabel>
              <MuiSelect
                label="MuiSelect File Type"
                onChange={handleSelectChange}
                value={fileType}
                size="small"
              >
                <MuiMenuItem value={QUALTRICS_FILE}>
                  {t("ExportFile.qualtrics_file")}
                </MuiMenuItem>
                <MuiMenuItem value={MARKETO_FILE}>
                  {t("ExportFile.marketo_file")}
                </MuiMenuItem>
              </MuiSelect>
            </MuiFormControl>
            <div style={{ marginTop: "7px" }}>{message}</div>
          </MuiDialogContent>
          <MuiDialogActions>
            <MuiButton
              autoFocus
              onClick={() => closeCancelASConfirmation(false)}
              color="primary"
            >
              {cancelLabel ? cancelLabel : "Cancel"}
            </MuiButton>
            <MuiButton
              onClick={() => closeCancelASConfirmation(true)}
              color="primary"
            >
              {okLabel ? okLabel : "OK"}
            </MuiButton>
          </MuiDialogActions>
        </MuiDialog>
      ) : (
        <ConfirmationDialog
          open={openASConfirmation}
          onClose={closeCancelASConfirmation}
          title={t("ExportFile.exportTitle")}
          message={t("ExportFile.exportMessage")}
          okLabel={t("common.yesLabel")}
          cancelLabel={t("common.noLabel")}
        />
      )}

      <div
        style={{
          color: Theme.palette.primary.dark,
          "&:hover": {
            cursor: "pointer",
          },
        }}
        onClick={handleClickImport}
      >
        {displayName}
      </div>
    </>
  );
};

export default Export;
